import React, { useState, useEffect } from 'react';
import { FaExclamationTriangle } from 'react-icons/fa';
import Navbar from '../Menus/Navbar'
import Footer from '../Menus/Footer'
import HOMEBANNER from '../images/MICRO1.png'

import { FaQuestionCircle } from "react-icons/fa";
import CountUp from 'react-countup';
import { FaSmile, FaMapMarkedAlt, FaThumbsUp } from 'react-icons/fa';
import { useInView } from 'react-intersection-observer';
import './Home.css'
import AOS from 'aos';
import { FaCalendarAlt, FaClock, FaHeadset } from 'react-icons/fa';
// import 'aos/dist/aos.css';
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import { motion } from "framer-motion";
import MICRO2 from '../images/MICRO2.jpg';

import MICRO3 from "../images/MICRO3.webp";
import MICRO4 from "../images/MICRO4.jpg";
import MICRO5 from "../images/MICRO5.jpg";
import MICRO6 from "../images/MICRO6.jpg";
import MICRO7 from "../images/MICRO7.jpg";


import { FaPhoneAlt } from 'react-icons/fa';
export default function Micro() {


  const faqs = [
    {
      question: "What makes your microwave oven service low-cost?",
      answer: "Our microwave oven service is affordable because we optimize our repair process, avoid unnecessary replacements, and focus on efficient troubleshooting. The cost savings are passed directly to customers."
    },
    {
      question: "What is your policy on repeat complaints?",
      answer: "If the same microwave oven issue occurs within one month of service, we will fix it free of charge with no additional service cost."
    },
    {
      question: "Do you provide a warranty on microwave spare parts?",
      answer: "Yes, all microwave oven spare parts come with a warranty ranging from 3 to 6 months, depending on the component and manufacturer."
    },
    {
      question: "Can I see the microwave spare parts before installation?",
      answer: "Yes. We show all microwave oven spare parts to customers before installation to maintain full transparency."
    },
    {
      question: "How can I schedule a microwave oven service?",
      answer: "You can call us anytime to book a microwave oven service. Our support team is available 24/7."
    },
    {
      question: "What types of microwave oven issues do you repair?",
      answer: "We repair all microwave oven problems including heating issues, turntable faults, control panel problems, power failures, and door switch issues."
    },
    {
      question: "Are your technicians trained for microwave oven repairs?",
      answer: "Yes, our technicians are professionally trained and experienced in repairing microwave ovens of all major brands and models."
    },
    {
      question: "Do you provide emergency microwave oven repair services?",
      answer: "Yes, we offer emergency microwave oven repair services for urgent breakdowns."
    },
    {
      question: "How can I extend the life of my microwave oven?",
      answer: "Proper usage, regular cleaning, and timely repairs can significantly extend your microwave oven’s lifespan. We also offer preventive maintenance services."
    },
    {
      question: "What should I do if I have more questions?",
      answer: "If you have any further questions about microwave oven service or repairs, contact us anytime. We’re always ready to help."
    }
  ];


  const tips = [
    {
      title: "Clean the Interior Regularly",
      content: "Wipe the microwave interior frequently to remove food splatters and prevent odor buildup."
    },
    {
      title: "Check the Door Seal",
      content: "Inspect the microwave door seal for damage to ensure proper heating and prevent energy leakage."
    },
    {
      title: "Use Microwave-Safe Utensils",
      content: "Always use microwave-safe containers to avoid melting, sparks, or harmful chemical release."
    },
    {
      title: "Avoid Running Empty",
      content: "Never operate the microwave without food inside, as it can damage internal components."
    },
    {
      title: "Keep the Turntable Clean",
      content: "Clean and properly position the turntable to ensure even heating and smooth rotation."
    },
    {
      title: "Do Not Overheat Food",
      content: "Overheating can damage containers and affect food quality. Use proper time settings."
    },
    {
      title: "Ensure Proper Ventilation",
      content: "Maintain sufficient airflow around the microwave to prevent overheating."
    },
    {
      title: "Check Power Cord Condition",
      content: "Regularly inspect the power cord for wear or damage to avoid electrical hazards."
    },
    {
      title: "Clean the Control Panel Carefully",
      content: "Use a soft cloth to clean the control panel to avoid damaging sensitive buttons."
    },
    {
      title: "Call a Professional When Needed",
      content: "If your microwave shows unusual noise, sparks, or heating issues, contact a certified technician immediately."
    }
  ];





  const accordionData = [
    {
      title: "Microwave Oven Repair Services",
      content: "We repair all types of microwave oven issues with accurate diagnosis and fast service."
    },
    {
      title: "Microwave Oven Maintenance",
      content: "Regular maintenance services to improve performance, safety, and lifespan of your microwave oven."
    },
    {
      title: "Microwave Oven Installation",
      content: "Safe and proper installation of countertop, grill, and convection microwave ovens."
    },
    {
      title: "Microwave Oven Troubleshooting",
      content: "We identify and fix heating issues, power failures, control panel errors, and unusual noises."
    },
    {
      title: "Microwave Oven Spare Parts Replacement",
      content: "Replacement of genuine microwave oven parts such as magnetron, door switch, turntable motor, and PCB."
    }
  ];



  const [activeIndex, setActiveIndex] = useState(null);

  const toggleAccordion = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };

  const toggleTip = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };
  const services = [
    { title: "Microwave Oven Repair", desc: "Accurate Fault Diagnosis", img: MICRO2 },
    { title: "Microwave Oven Maintenance", desc: "Preventive Safety Check", img: MICRO3 },
    { title: "Microwave Oven Installation", desc: "Safe & Proper Setup", img: MICRO4 },
    { title: "Microwave Oven Servicing", desc: "Heating & Power Issues", img: MICRO5 },
    { title: "Microwave Parts Replacement", desc: "Magnetron, PCB & Switch", img: MICRO6 },
    { title: "Microwave Oven Cleaning", desc: "Internal Deep Cleaning", img: MICRO7 },
  ];



  const [ref, inView] = useInView({ triggerOnce: true });

  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    city: '',
    appliance: '',
    issue: ''
  });

  const handleChange = e => {
    setFormData(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };

  const handleSubmit = e => {
    e.preventDefault();
    const { name, phone, city, appliance, issue } = formData;
    const message = `New Complaint:%0AName: ${name}%0APhone: ${phone}%0ACity: ${city}%0AAppliance: ${appliance}%0AIssue: ${issue}`;
    const whatsappURL = `https://wa.me/919342851992?text=${message}`; // Replace with your number
    window.open(whatsappURL, '_blank');
  };







  return (
    <>
      <Navbar />

      <section id="Banner-home" className="banner-home" style={{ backgroundImage: `url(${HOMEBANNER})` }}>
        <div className="banner-overlay">
          <div className="banner-container">
            {/* Left Side */}
            <div className="banner-left glass-effect">
              <h1 className="headline">Microwave Oven Service Center</h1>
              <a href="tel:+919342851992" className="call-btn">
                <FaPhoneAlt style={{ marginRight: '8px' }} />
                +919342851992
              </a>
            </div>

            {/* Right Side - Contact Form */}
            <div className="banner-right">
              <form className="contact-form" onSubmit={handleSubmit}>
                <input type="text" name="name" placeholder="Your Name" required onChange={handleChange} />
                <input type="tel" name="phone" placeholder="Phone Number" required onChange={handleChange} />
                <input type="text" name="city" placeholder="City" required onChange={handleChange} />
                <select name="appliance" required onChange={handleChange}>
                  <option value="">Select Appliance</option>
                  <option value="Washing Machine">Washing Machine</option>
                  <option value="Refrigerator">Refrigerator</option>
                  <option value="Microwave Oven">Microwave Oven</option>
                  <option value="AC">AC</option>
                  <option value="TV">TV</option>
                </select>
                <textarea name="issue" placeholder="Tell us your issue..." required onChange={handleChange}></textarea>
                <button type="submit" className="submit-btn">Submit & Send to WhatsApp</button>
              </form>
            </div>
          </div>
        </div>
      </section>




      <section id="home-about">
        <div className="about-container">
          {/* Left Side */}
          <div className="about-left" data-aos="fade-left">
            <h2>About Our Company</h2>
            <h3>Home Appliance Assist</h3>
            <p>
              If your microwave oven stops working, don’t panic. Contact us and we’ll resolve the issue quickly and professionally. We provide convenient, on-site microwave oven repair services — simply book a service call and our technicians will visit your home. You can also bring your microwave oven to our service center for prompt repair. We offer reliable and expert microwave oven services for all brands and models, including solo, grill, and convection microwaves. With over <strong>8+ years</strong> of experience in the appliance service industry, we are committed to quality workmanship and complete customer satisfaction.
            </p>


            <img src={MICRO2} alt='washing machine service' title='washing machine repair' className='img-fluid' />
          </div>

          {/* Right Side Boxes */}
          <div className="about-right">
            <h3>Issue In Microwave Oven</h3>
            <div className="service-box" data-aos="fade-right" data-aos-delay="100">
              <p>Microwave Oven Not Powering On</p>
            </div>
            <div className="service-box" data-aos="fade-right" data-aos-delay="200">
              <p>Microwave Not Heating Food</p>
            </div>
            <div className="service-box" data-aos="fade-right" data-aos-delay="300">
              <p>Turntable Not Rotating</p>
            </div>
            <div className="service-box" data-aos="fade-right" data-aos-delay="400">
              <p>Unusual Noise During Operation</p>
            </div>
            <div className="service-box" data-aos="fade-right" data-aos-delay="500">
              <p>Sparking Inside Microwave</p>
            </div>
            <div className="service-box" data-aos="fade-right" data-aos-delay="600">
              <p>Microwave Stops Mid-Cycle</p>
            </div>
            <div className="service-box" data-aos="fade-right" data-aos-delay="700">
              <p>Control Panel or Touch Pad Not Working</p>
            </div>
            <div className="service-box" data-aos="fade-right" data-aos-delay="800">
              <p>Burning Smell or Overheating Issue</p>
            </div>
            <div className="service-box" data-aos="fade-right" data-aos-delay="900">
              <p>Door Not Closing or Safety Switch Fault</p>
            </div>
            <div className="service-box" data-aos="fade-right" data-aos-delay="1000">
              <p>Microwave Cleaning & Preventive Maintenance</p>
            </div>


          </div>
        </div>
      </section>



      <section id="washing-machine-service" className="washing-service-section">
        <h2 className="section-title">What We Do for Microwave Oven Service</h2>
        <div className="washing-service-grid">
          {services.map((service, index) => (
            <motion.div
              className="washing-card"
              key={index}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.2 }}
              viewport={{ once: true }}
            >
              <img src={service.img} alt={service.title} className="washing-img" />
              <h3>{service.title}</h3>
              <p>{service.desc}</p>
            </motion.div>
          ))}
        </div>
      </section>

      <section id="washing-accordion-section" className="accordion-wrapper">
        <div className="accordion-container">
          <div className="accordion-image">
            <img src={MICRO7} alt="Washing Machine Service" />
          </div>
          <div className="accordion-content">MICRO7
            <h2>Microwave Oven Service Details</h2>
            {accordionData.map((item, index) => (
              <div className="accordion-item" key={index}>
                <div
                  className={`accordion-title ${activeIndex === index ? "active" : ""}`}
                  onClick={() => toggleAccordion(index)}
                >
                  <h3>{item.title}</h3>
                  <span>{activeIndex === index ? <FaChevronUp /> : <FaChevronDown />}</span>
                </div>
                <div
                  className={`accordion-body ${activeIndex === index ? "open" : ""}`}
                >
                  <p>{item.content}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>


      {/*    
   <section id="desc" className="service-section">
     <div className="service-item" data-aos="fade-right">
       <div className="service-text">
         <h2>Washing Machine Issues?</h2>
         <p>
           Is your washing machine making noise, not spinning, or leaking water? Don’t worry — our trained experts diagnose and fix all issues quickly. 
           We offer <strong>same-day doorstep service</strong> to get your appliance back up and running smoothly.
         </p>
         <a href="/washing-machine-service" className="service-btn">Fix Now</a>
       </div>
       <div className="service-image" data-aos="fade-left">
         <img src={WASHINGMACHINE} alt="Washing Machine Service" />
       </div>
     </div>
   
     <div className="service-item" data-aos="fade-right">
       <div className="service-text">
         <h2>AC Not Cooling?</h2>
         <p>
           Whether it's low cooling, water leakage, or unusual noise, our technicians provide <strong>same-day AC repair</strong> with expert diagnostics and professional care.
         </p>
         <a href="/ac-service" className="service-btn">Fix Now</a>
       </div>
       <div className="service-image" data-aos="fade-left">
         <img src={AC} alt="AC Service" />
       </div>
     </div>
   
     <div className="service-item" data-aos="fade-right">
       <div className="service-text">
         <h2>Fridge Not Working?</h2>
         <p>
           Experiencing cooling issues or strange noises? Let our experienced technicians help. We offer <strong>quick same-day service</strong> for all fridge problems.
         </p>
         <a href="/fridge-service" className="service-btn">Fix Now</a>
       </div>
       <div className="service-image" data-aos="fade-left">
         <img src={REF} alt="Fridge Service" />
       </div>
     </div>
   
     <div className="service-item" data-aos="fade-right">
       <div className="service-text">
         <h2>TV Not Turning On?</h2>
         <p>
           From screen issues to sound problems, we repair all types of TVs — LED, LCD, Smart TVs and more. Our <strong>same-day service</strong> ensures quick solutions.
         </p>
         <a href="/tv-service" className="service-btn">Fix Now</a>
       </div>
       <div className="service-image" data-aos="fade-left">
         <img src={TV} alt="TV Service" />
       </div>
     </div>
   </section>
   
   

   
    */}



      <section id="washing-tips-section" className="tips-wrapper">
        <div className="tips-container">
          <h2>Microwave Oven Tips and Tricks</h2>
          <div className="tips-accordion">
            {tips.map((tip, index) => (
              <div className="tip-item" key={index}>
                <div className="tip-header" onClick={() => toggleTip(index)}>
                  <h3>{index + 1}. {tip.title}</h3>
                  <span>{activeIndex === index ? <FaChevronUp /> : <FaChevronDown />}</span>
                </div>
                <div className={`tip-body ${activeIndex === index ? "open" : ""}`}>
                  <p>{tip.content}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>


      <section id="why-us" className="why-us-section">
        <div className="why-us-heading" data-aos="fade-up">
          <h2>Why Choose Us?</h2>
        </div>
        <div className="why-us-grid">
          <div className="why-us-card" data-aos="fade-right">
            <h3>Expert Technicians</h3>
            <p>Our team consists of certified experts with years of experience in appliance repairing and maintenance.</p>
          </div>
          <div className="why-us-card" data-aos="fade-left">
            <h3>Quick Service</h3>
            <p>We value your time and offer prompt service, ensuring your appliances are up and running in no time.</p>
          </div>
          <div className="why-us-card" data-aos="fade-right">
            <h3>Quality Assurance</h3>
            <p>We use genuine parts and provide a guarantee on our work, so you can trust in the quality of our service.</p>
          </div>
          <div className="why-us-card" data-aos="fade-left">
            <h3>Affordable Pricing</h3>
            <p>Our pricing is transparent and competitive, ensuring you get the best value for your money.</p>
          </div>
        </div>
      </section>

      <section id="impact" className="impact-section" ref={ref}>
        <h2 className="impact-heading" data-aos="fade-up">Our Impact in Numbers</h2>
        <div className="impact-container">
          <div className="impact-card" data-aos="fade-up" data-aos-delay="100">
            <FaSmile className="impact-icon" />
            <h2>{inView && <CountUp end={50000} duration={2} />}+</h2>
            <p>Happy Customers</p>
          </div>
          <div className="impact-card" data-aos="fade-up" data-aos-delay="200">
            <FaMapMarkedAlt className="impact-icon" />
            <h2>{inView && <CountUp end={60} duration={2} />}+</h2>
            <p>Areas Covered</p>
          </div>
          <div className="impact-card" data-aos="fade-up" data-aos-delay="300">
            <FaThumbsUp className="impact-icon" />
            <h2>{inView && <CountUp end={49000} duration={2} />}+</h2>
            <p>Satisfied Customers</p>
          </div>
        </div>
      </section>
      <section id="washing-faq-section" className="faq-section">
        <div className="faq-container">
          <h2>Frequently Asked Questions</h2>
          <div className="faq-grid">
            {faqs.map((faq, index) => (
              <div className="faq-card" key={index}>
                <div className="faq-icon">
                  <FaQuestionCircle />
                </div>
                <h3 className="faq-question">{faq.question}</h3>
                <p className="faq-answer">{faq.answer}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section id="availability" className="availability-section">
        <h2 className="availability-heading" data-aos="fade-up">Our Availability</h2>
        <div className="availability-grid">
          <div className="availability-card" data-aos="fade-right">
            <FaCalendarAlt className="availability-icon" />
            <h3>Opening Day</h3>
            <p>
              Monday to Saturday <br />
              <span className="sunday-text">Sunday - Closed</span>
            </p>
          </div>
          <div className="availability-card" data-aos="fade-up">
            <FaClock className="availability-icon" />
            <h3>Office Available</h3>
            <p>9:00 AM to 9:00 PM</p>
          </div>
          <div className="availability-card" data-aos="fade-left">
            <FaHeadset className="availability-icon" />
            <h3>Customer Support</h3>
            <p>24/7 Available</p>
          </div>
        </div>
      </section>


      <section id="disclaimer" className="disclaimer-section" data-aos="fade-up">
        <div className="disclaimer-container">
          <div className="disclaimer-icon">
            <FaExclamationTriangle />
          </div>
          <div className="disclaimer-content">
            <h2>Disclaimer</h2>
            <p>
              Home Appliance Assist is an independent service provider offering expert repairing and maintenance services for a wide range of home appliances. We specialize in servicing all major home appliance types, including refrigerators, washing machines, air conditioners, and televisions.
            </p>
            <p>
              Please note that Home Appliance Assist is not affiliated with, endorsed by, or associated with any specific appliance manufacturers or brands. We do not use any brand names, trademarks, or logos on our website or in our promotional materials. All services provided are carried out by our team of experienced and certified technicians, independent of any manufacturer's certification.
            </p>
            <p>
              While we provide high-quality service for various appliance types, our services are not authorized by or affiliated with the manufacturers of the products we repair. Customers seeking manufacturer-authorized service and genuine parts should contact the official customer support of the respective brands.
            </p>
          </div>
        </div>
      </section>

      <Footer />
    </>
  )
}
